export default __webpack_public_path__ + "static/allProjects-ebba545e8207c0f87af5131c83375751.png";